import React from "react";
import "./HeroIntro.css";
import CardSlider from "../CardSlider/CardSlider";
import Button from "../Button/Button";

const truncateText = (text, maxLines) => {
  // Trim leading/trailing spaces and remove any leading periods
  text = text.trim().replace(/^\./, '');

  const lines = text.split('. ').reduce((acc, sentence) => {
    const currentLine = acc[acc.length - 1] || '';
    const newLine = currentLine.length > 0 ? `${currentLine}. ${sentence}` : sentence;

    if (newLine.length <= maxLines * 30) { // Adjust length for your line width
      acc[acc.length - 1] = newLine;
    } else {
      acc.push(sentence);
    }
    return acc;
  }, ['']);

  return lines.map((line, index) => (
    <span key={index}>
      {line}
      {index < lines.length - 1 && '.'}
      <br />
    </span>
  ));
};


const HeroIntro = ({ data, services, products }) => {
  return (
    <div className="HeroIntro-Container">
      <div className="HeroIntro-Left">
        <h1 className="HeroIntro-HeadingLeft">{data.ElementHeadingLeft}</h1>
        <p className="HeroIntro-Description">
          {truncateText(data.ElementHeadingLeftDescription, 3)}
        </p>
        <Button to="/contact">{data.ElementGetAQuote}</Button>
      </div>
      <div className="HeroIntro-Right">
        <div className="HeroIntro-UpperSlider">
          <div className="HeroIntro-RightHeading">
            <h1 className="HeroIntro-SliderHeading">{data.ElementSliderHeading1}</h1>
            <p className="HeroIntro-RightParagraph">
              {truncateText(data.ElementSliderDescription1, 3)}
            </p>
          </div>
          <div className="HeroIntro-CardSliders">
            <CardSlider data={services} CurrentPage={data.ElementLinkCapabilities} />
          </div>
        </div>
        <div className="HeroIntro-LowerSlider">
          <div className="HeroIntro-RightHeading">
            <h1 className="HeroIntro-SliderHeading">{data.ElementSliderHeading2}</h1>
            <p className="HeroIntro-RightParagraph">
              {truncateText(data.ElementSliderDescription2, 3)}
            </p>
          </div>
          <div className="HeroIntro-CardSliders">
            <CardSlider data={products} CurrentPage={data.ElementLinkIndustries} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroIntro;
